import React from 'react';
import PropTypes from 'prop-types';
import {Form} from 'formik';
import styles from './styles.module.scss';
import FieldInput from "common/components/FieldInput";
import closeButton from "../../assets/close_button.svg";
import FieldTextareaAutosize from "../FieldTextareaAutosize";

const ContactView = ({
                       values,
                       onSubmitClick,
                       modalContactSlide,
                       slideModalContact
                     }) => {

  return (
    <div className={modalContactSlide ? styles.desktopModalContactShow : styles.desktopModalContactHide}>
      <img
        src={closeButton}
        alt="close-button"
        onClick={slideModalContact}
        className={styles.contactCloseButton}
      />
      <Form className={styles.contactForm}>
        <h2 className={styles.header}>צור קשר</h2>
        <div className={styles.text}> אנא השאר הודעה ונחזור אליך בהקדם ליצירת קשר</div>
        <div className={styles.contactName}>
          <FieldInput
            fieldId="fullName"
            type={"text"}
            value={values.fullName}
            label="שם"
          />
        </div>
        <div className={styles.contactEmail}>
          <FieldInput
            fieldId="email"
            type={"email"}
            value={values.email}
            label="כתובת אימייל"
          />
        </div>
        <div className={styles.contactMessage}>
          <FieldTextareaAutosize
            fieldId="message"
            value={values.message}
            label="הודעה"
            customTextareaStyles={styles.customTextareaStyles}
            showBird={false}
          />
        </div>
        <button
          type="submit"
          className={styles.submitButton}
          disabled={!(values.fullName && values.message && values.email)}
          onClick={onSubmitClick}
        >
          שלח הודעה
        </button>
      </Form>
    </div>
  )
}


ContactView.propTypes = {
  values: PropTypes.object
};

export default ContactView;



